import { hbs } from 'ember-cli-htmlbars';
export default hbs("<BvDateRangeField\n  @value={{this.dateFilter}}\n  @onChange={{optional @onFilter}}\n  @inlineCalendar={{true}}\n  @calendarSize=\"md\"\n  ...attributes\n/>")